window.PH = window.PH || {};

PH.intents = {
  list: [
    {
      id: 'elegante',
      label: 'Elegante',
      icon: '✨',
      triggers: ['elegante', 'sofisticado', 'premium', 'lujoso', 'fino', 'formal', 'distinguido'],
      title: 'Recomendación PH elegante',
      description: 'Opciones sofisticadas, versátiles y con presencia para proyectar buen gusto.',
      weights: {
        moods: {
          elegante: 60,
          sofisticado: 45,
          versatil: 25,
          limpio: 20
        },
        occasions: {
          oficina: 30,
          evento: 35,
          noche: 25,
          diario: 15
        },
        family: {
          amaderado: 35,
          fresco: 20,
          ambar: 25,
          cuero: 20
        },
        seasons: {
          todo_el_ano: 20,
          noche: 15,
          invierno: 10
        }
      },
      minScore: 45,
      maxResults: 6
    },

    {
      id: 'cita',
      label: 'Cita',
      icon: '❤️',
      triggers: ['cita', 'citas', 'romantico', 'romantica', 'ligar', 'seductor', 'seductora', 'salir con alguien', 'date'],
      title: 'Recomendación PH para cita',
      description: 'Te sugerimos aromas seductores, elegantes y con buena presencia.',
      weights: {
        moods: { seductor: 45, elegante: 25, femenino: 20, sofisticado: 20 },
        occasions: { cita: 60, noche: 25, fiesta: 15 },
        family: { dulce: 35, floral: 25, ambar: 25, frutal: 15 },
        seasons: { noche: 15, invierno: 10, otoño: 10 }
      },
      minScore: 60,
      maxResults: 6
    },

    {
      id: 'oficina',
      label: 'Oficina',
      icon: '💼',
      triggers: ['oficina', 'trabajo', 'formal', 'ejecutivo', 'diario', 'junta', 'reunion'],
      title: 'Recomendación PH para oficina',
      description: 'Estas opciones son versátiles, limpias y elegantes para uso diario.',
      weights: {
        moods: { limpio: 40, elegante: 35, versatil: 35, sofisticado: 20 },
        occasions: { oficina: 60, diario: 35, cita_casual: 10 },
        family: { fresco: 35, amaderado: 25, aromatico: 25, citrico: 20 },
        seasons: { calor: 20, verano: 15, primavera: 15, todo_el_ano: 20 }
      },
      minScore: 55,
      maxResults: 6
    },

    {
      id: 'calor',
      label: 'Calor',
      icon: '☀️',
      triggers: ['calor', 'verano', 'playa', 'fresco', 'fresca', 'merida', 'dia', 'clima caliente'],
      title: 'Recomendación PH para clima cálido',
      description: 'Elegimos aromas frescos, limpios y fáciles de usar en calor.',
      weights: {
        moods: { fresco: 45, limpio: 35, verano: 30 },
        occasions: { calor: 50, playa: 45, diario: 25 },
        family: { citrico: 45, acuatico: 45, fresco: 40, aromatico: 20 },
        seasons: { verano: 50, primavera: 25, calor: 45 }
      },
      minScore: 55,
      maxResults: 6
    },

    {
      id: 'noche',
      label: 'Noche',
      icon: '🌙',
      triggers: ['noche', 'fiesta', 'antro', 'salida', 'bar', 'evento'],
      title: 'Recomendación PH para noche',
      description: 'Estas opciones tienen más presencia y carácter para destacar.',
      weights: {
        moods: { intenso: 45, seductor: 40, exclusivo: 30, sofisticado: 25 },
        occasions: { noche: 60, fiesta: 40, evento: 30 },
        family: { dulce: 25, ambar: 35, cuero: 35, especiado: 30 },
        seasons: { noche: 25, invierno: 20, otoño: 20 }
      },
      minScore: 55,
      maxResults: 6
    },

    {
      id: 'dulce',
      label: 'Dulce',
      icon: '🍬',
      triggers: ['dulce', 'vainilla', 'caramelo', 'chocolate', 'gourmand'],
      title: 'Recomendación PH de aromas dulces',
      description: 'Perfumes con perfil dulce, envolvente y muy agradable.',
      weights: {
        moods: { dulce: 45, seductor: 25, femenino: 20 },
        occasions: { cita: 30, noche: 25, evento: 15 },
        family: { dulce: 60, gourmand: 50, ambar: 25, floral: 15 },
        notes: { vainilla: 50, cacao: 35, tonka: 35, praline: 35 }
      },
      minScore: 50,
      maxResults: 6
    }
  ],

  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  detect(query) {
    const q = this.normalize(query);
    if (q.length < 2) return null;

    return this.list.find(intent =>
      intent.triggers.some(trigger => q.includes(this.normalize(trigger)))
    ) || null;
  }
};